import React, { useEffect, useRef } from 'react';
import { useChatbot } from './ChatbotContext';
import ChatbotMessage from './ChatbotMessage';
import ChatbotTypingIndicator from './ChatbotTypingIndicator';

/**
 * Lista de mensagens da conversa com auto-scroll
 */
const ChatbotMessages = () => {
  const { messages, isTyping } = useChatbot();
  const messagesEndRef = useRef(null);

  // Auto-scroll para o final quando novas mensagens chegam
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isTyping]);

  if (messages.length === 0 && !isTyping) {
    return (
      <div className="chatbot-messages chatbot-messages-empty">
        <div className="chatbot-welcome">
          <div className="chatbot-welcome-avatar">P</div>
          <h6>Olá! Sou o Phada</h6>
          <p>Seu copiloto no Phada ERP. Posso responder dúvidas, analisar dados em tempo real e sugerir ações.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="chatbot-messages">
      {messages.map((msg) => (
        <ChatbotMessage key={msg.id} message={msg} />
      ))}
      {isTyping && <ChatbotTypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatbotMessages;
